import React from 'react'
import GamesDirectory from './GamesDirectory'
import CategoryPage from './CategoryPage'

/** Route entry for /games and /games/:category */
const Games = ({ match, history }) => {
  const { category } = match.params

  if (category) {
    return <CategoryPage category={category} history={history} />
  }

  return <GamesDirectory history={history} />
}

export default Games
